import { updateFilterCriteria, filterCommunities, getFilterCriteria } from '../maps/filter';
import { renderEstateCards } from './renderEstateCards';

// Default Settings
var globals = {};
var markerIcons = {
    active: {},
    inactive: {},
    comingActive: {},
    comingInactive: {},
    soldActive: {},
    soldInactive: {}
};
var markers = [];
const data = {
    communities: []
};
var gtmCommunities = {};
function community(name = "", region = "", projectStatus = "") {
    this.name = name;
    this.region = region;
    this.availability = projectStatus;
    return this;
}


export const communities = async (g) => {
    globals = g;

    // Calculate the projects endpoint
    var endPoint = globals.parentFolderIds
        ? globals.apiRoot + '/projects?parentId=' + globals.parentFolderIds.join("&parentId=")
        : globals.apiRoot + '/projects';

    // Initilize default marker styles
    markerIcons.inactive = {
        url: '/images/pin-icon-available.svg',
        size: new google.maps.Size(38, 60),
        scaledSize: new google.maps.Size(38, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 60)
    };
    markerIcons.active = {
        url: '/images/pin-icon-available-active.svg',
        size: new google.maps.Size(38, 60),
        scaledSize: new google.maps.Size(38, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 60)
    };

    // Coming soon markers
    markerIcons.comingInactive = {
        url: '/images/pin-icon-coming.svg',
        size: new google.maps.Size(38, 60),
        scaledSize: new google.maps.Size(38, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 60)
    };
    markerIcons.comingActive = {
        url: '/images/pin-icon-coming-active.svg',
        size: new google.maps.Size(38, 60),
        scaledSize: new google.maps.Size(38, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 60)
    };

    // Sold markers
    markerIcons.soldInactive = {
        url: '/images/pin-icon-sold.svg',
        size: new google.maps.Size(38, 60),
        scaledSize: new google.maps.Size(38, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 60)
    };
    markerIcons.soldActive = {
        url: '/images/pin-icon-sold-active.svg',
        size: new google.maps.Size(38, 60),
        scaledSize: new google.maps.Size(38, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 60)
    };

    $.when($.ajax(endPoint))
        .done(function (response) {
            //for testing purpoises
            //console.log("i'm going to pause");
            //var start = new Date().getTime();
            //var end = start;
            //while (end < start + 10000) {
            //    end = new Date().getTime();
            //}
            //console.log("finished pausing");

            // Set up data
            data.communities = response;

            // Set the clusterer
            var clusterOptions = {
                ignoreHidden: true,
                minimumClusterSize: 2,
                styles: [{ textColor: "#FFFFFF", textSize: 14, width: 56, height: 56, url: '/images/cluster-icon.png' }]
            };
            globals.cluster = new MarkerClusterer(globals.map, markers, clusterOptions);

            // Render the communities and cards
            renderCommunities(data.communities);
            renderEstateCards('product-card-wrapper', data.communities);

            // Initialise the controls and toggles
            initializeControls();
            enableViewTogglers();

            enableSearchStates();
            setAutoComplete(data.communities);

            setMapHeight();
            setFixedFilterScroll();
            gtmViewCommunityList(data.communities); // in here GTM fire first loaded event (View Community List)
            hideLoader();

        })
        .fail(function () {
            console.log(arguments);
        })
};

function renderCommunities(data) {
    // Remove any existing markers
    markers.forEach(marker => {
        globals.cluster.removeMarker(marker);
        marker.setMap(null);
    });
    markers = [];

    // Iterate between each data point and create a new marker
    data.forEach(community => {
        if (community.lat && community.lng && community.projectStatus == 'coming') {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(community.lat, community.lng),
                icon: markerIcons.comingInactive,
                label: {
                    text: community.name,
                    className: 'product-search__map-marker-label',
                    fontSize: "12px",
                    fontWeight: "700",
                    color: '#30424C'
                }
            });

            // Attach click event to the marker...
            google.maps.event.addListener(marker, "click", function () {
                const contentString = infoWindowMarkup(community)
                globals.showHideInfoWindow(marker, contentString);
                marker.setIcon(markerIcons.comingActive);
            });

            // Add marker to cluster and marker list
            globals.cluster.addMarker(marker);
            markers.push(marker);
        }

        else if (community.lat && community.lng && community.projectStatus == 'sold') {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(community.lat, community.lng),
                icon: markerIcons.soldInactive,
                label: {
                    text: community.name,
                    className: 'product-search__map-marker-label',
                    fontSize: "12px",
                    fontWeight: "700",
                    color: '#30424C'
                }
            });

            // Attach click event to the marker...
            google.maps.event.addListener(marker, "click", function () {
                const contentString = infoWindowMarkup(community)
                globals.showHideInfoWindow(marker, contentString);
                marker.setIcon(markerIcons.soldActive)
            });

            // Add marker to cluster and marker list
            globals.cluster.addMarker(marker);
            markers.push(marker);
        }

        else if (community.lat && community.lng && community.projectStatus !== 'coming' && community.projectStatus !== 'sold') {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(community.lat, community.lng),
                icon: markerIcons.inactive,
                label: {
                    text: community.name,
                    className: 'product-search__map-marker-label',
                    fontSize: "12px",
                    fontWeight: "700",
                    color: '#30424C'
                }
            });

            // Attach click event to the marker...
            google.maps.event.addListener(marker, "click", function () {
                const contentString = infoWindowMarkup(community)
                globals.showHideInfoWindow(marker, contentString);

                marker.setIcon(markerIcons.active)
            });

            // Add marker to cluster and marker list
            globals.cluster.addMarker(marker);
            markers.push(marker);
        }

    });

    // Only fix the bounds if there are markers
    if (markers && markers.length > 0) {
        // globals.cluster.fitMapToMarkers();
        setMapBounds()
    }

    
}


function setMapBounds() {

    var bounds;

    if (markers.length) {

        var firstMarker = markers[0];
        bounds = new google.maps.LatLngBounds(firstMarker.position, firstMarker.position);

        markers.forEach(marker => {
            bounds.extend(marker.position);
        })

        // Create a min bounds size for filtering (prevents zooming too far without restricting manual zoom)
        var boundsMin = 0.02;
        var latDif = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();
        var lngDif = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
        if (latDif < boundsMin || lngDif < boundsMin) {
            var lngBuff = boundsMin - lngDif;
            var latBuff = boundsMin - latDif;
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + latBuff, bounds.getNorthEast().lng() + lngBuff);
            var extendPoint2 = new google.maps.LatLng(bounds.getSouthWest().lat() - latBuff, bounds.getSouthWest().lng() - lngBuff);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }

        globals.map.fitBounds(bounds);

    }

};


function infoWindowMarkup(community) {
    // add data object to this html to allow the dataLayer to get data about this community
    let dataHTML = 'data-name="'+community.name+'" data-region="'+community.region+'" data-availablity="'+community.projectStatus+'"';

    let communityHTML = '';

    // Set the community image
    var communityImage = (
        '<a class="product-info__elevation" href="' + community.url + '" style="background-image:url(' + community.thumbnailImageUrl + ')"></a>'
    );

    // Set the community header
    var communityHeader = '';
    if (community.logoUrl !== null) {
        communityHeader = (
            '<div class="product-info__logo" style="background-image:url(' + community.logoUrl + ')"></div>'
        );
    }
    else {
        communityHeader = (
            '<h4 class="product-info__name">' + community.name + '</h4>'
        );
    }

    // Set the community links //TODO need to figure out how to identify for the community in GTM thing here to handle the (Select Item from Map) event which is supposed to happen on click on the thumbnail or more info button on map view (product-info__more)
    // Have added id constructed with prefix of GTMCommId_ and community name (guid not available at this point). This will hopefully give us enough to get data from elsewhere.
    var communityLink = '';
    if (community.url !== '') {
        communityLink = (
            '<div class="product-info__more">' +
            '<a href="' + community.url + '" target="_blank" id="' + "GTMCommId_" + community.name + '" class="product-info__more-information mdl-button mdl-js-button mdl-button--raised mdl-button--colored">More information</a>' +
            '</div>'
        );

        
    }

    // Set the community HTML
    communityHTML = (
        '<div class="estate-info product-info">' +
        communityImage +
        '<div class="product-info__details">' +
        communityHeader +
        '<p class="product-info__address">' + community.address + '</p>' +
        '<div class="product-info__details-text">' + community.description + '</div>' +
        communityLink +
        '</div>' +
        '</div>'
    );

    // Create final card html and return
    let cardHTML = (
        '<div class="product-info__window">' +
        '<div class="product-info__wrapper">' +
        '<div class="product-info__container" ' +
        dataHTML +
        '>' +
        communityHTML +
        '</div>' +
        '</div>' +
        '</div>'
    );

    return cardHTML;
}

export const deactivateCommunityMarkers = () => {
    // markers.forEach(marker => marker.setIcon(markerIcons.inactive));
    markers.forEach(function (marker) {
        var markerUrl = marker.icon.url;
        if (markerUrl == markerIcons.active.url) { marker.setIcon(markerIcons.inactive) }
        if (markerUrl == markerIcons.comingActive.url) { marker.setIcon(markerIcons.comingInactive) }
        if (markerUrl == markerIcons.soldActive.url) { marker.setIcon(markerIcons.soldInactive) }
    });
}


const updateSearch = (inputValue, action, input) => {
    if (inputValue) {
        // Update the filter criteria based on the input value and action
        updateFilterCriteria({ update: inputValue, action });

        // Filter the data and render the markers and cards
        var filteredData = filterCommunities(clone(data.communities));
        renderCommunities(filteredData);
        renderEstateCards('product-card-wrapper', filteredData);
        setAutoComplete(filteredData);
        populateDataLayerObject(filteredData);
    }
};

function populateDataLayerObject(data) { //this allows me to update an array of community objects I can attached to a datalayer push later.
    gtmCommunities = [];
    
    data.forEach(function (item) {
        gtmCommunities.push(new community(item.name, item.region, item.projectStatus));
    });
}

function initializeControls() {
    // set from querystring
    var inputs = document.getElementsByClassName('product-search__filter-checkbox');
    for (var i = 0; i < inputs.length; i++) {
        var diff = 0;
        if (globals.productFilter !== null) {
            // to ensure if parameter includes 'Land' that it is not part of 'HouseAndLand'. diff in index must not be 3
            // they don't expect to use multiple product types in the parameters and trying to find a solution that doesn't require changing the keyword everywhere is fraught.
            var indexOfAnd = globals.productFilter.indexOf("And");
            var indexOfValue = globals.productFilter.indexOf(inputs[i].value);
            diff = indexOfValue - indexOfAnd;
        }

        if ((!globals.productFilter || globals.productFilter.indexOf(inputs[i].value) >= 0) && diff !== 3) {
            inputs[i].checked = 'checked';
        }
    }
    var regions = document.getElementsByClassName('product-search__filter-select').Region;
    var regionValue = document.getElementsByClassName('product-search__filter-select-value');
    if (globals.regionFilter !== null && typeof (regions) !== 'undefined') {  // if regions not on this this page skip this
        regions.value = globals.regionFilter;
        for (var j = 0; j < regions.length; j++) {
            if (regions[j].value == globals.regionFilter) {
                regionValue[0].innerText = regions[j].text;
            }
        }
    }

    var status = document.getElementsByClassName('product-search__filter-radiobutton');
    if (globals.statusFilter !== null) {
        for (var k = 0; k < status.length; k++) {
            if (status[k].value == globals.statusFilter) {
                status[k].checked = 'checked';
            }
        }
    }

    // Iterate between each checkbox and add the change event
    Array.from(document.querySelectorAll('.product-search__filter-checkbox')).forEach((input) => {
        input.addEventListener('change', () => {
            updateSearch({ [input.name]: input.value }, input.checked ? 'APPEND' : 'REMOVE');
            gtmEventFilters(getFilterCriteria())
        });
        if (input.checked) {
            updateSearch({ [input.name]: input.value }, 'APPEND');
        }
    });

    // Change event for dropdown select filters
    Array.from(document.querySelectorAll('.product-search__filter-select')).forEach((input) => {
        const selectedValue = () => {
            const options = input.children;
            if (options && options.length >= (input.selectedIndex + 1)) {
                const selected = options[input.selectedIndex];
                return selected && selected.value && selected.value !== '' ? selected.value : false;
            }
            return false;
        };

        input.addEventListener('change', () => {
            updateSearch({ [input.name]: selectedValue() });
            gtmEventFilters(getFilterCriteria())
        });
        if (selectedValue()) {
            updateSearch({ [input.name]: selectedValue() });
        }
    });

    // Iterate between each radio button and add the change event
    Array.from(document.querySelectorAll('.product-search__filter-radiobutton')).forEach((input) => {
        input.addEventListener('change', () => {
            updateSearch({ [input.name]: input.value });
            gtmEventFilters(getFilterCriteria())
        });
        if (input.checked && input.value) {
            updateSearch({ [input.name]: input.value });
        }
    });

    // Change event for autocomplete search input
    Array.from(document.querySelectorAll('.product-search__filter-search')).forEach((input) => {
        const inputValue = () => {
            const value = input.value;
            if (value.length > 3) { return value; }
        };

        input.addEventListener('keyup', () => {
            updateSearch({ [input.name]: inputValue() });
        });
        $('#filter-search-autocomplete').on('autocompleteclose', function (event, ui) {
            updateSearch({ [input.name]: inputValue() });
            gtmEventFilters(getFilterCriteria())
        });
        if (inputValue()) {
            updateSearch({ [input.name]: inputValue() });
        }
    });

}

function enableViewTogglers() {
    var defaultView = 'list';
    document.getElementById('product-search-view').classList.add(defaultView + '-view');
    document.getElementById('filter-view-' + defaultView).setAttribute('checked', 'checked');

    var viewTypeRadios = document.getElementsByName('productViewType');
    for (var i = 0; i < viewTypeRadios.length; i++) {
        viewTypeRadios[i].onchange = toggleResultsView;
    }

    document.getElementById('filter-toggle').addEventListener('click', toggleFilterView);
    document.getElementById('filter-close').addEventListener('click', toggleFilterView);
    document.getElementById('filter-close-mobile').addEventListener('click', toggleFilterView);
}

function toggleResultsView() {
    var productSearchWrapper = document.getElementById('product-search-view');
    productSearchWrapper.classList.toggle('map-view');
    productSearchWrapper.classList.toggle('list-view');
    // globals.cluster.fitMapToMarkers();
    setMapBounds()

    // GTM (Google Tag Manager) Data Layer Update
    var viewTypeRadios = document.getElementsByName('productViewType');
    for (var i = 0; i < viewTypeRadios.length; i++) {
        if (viewTypeRadios[i].checked) {
            gtmEventViewToggle(viewTypeRadios[i].value);
        }
    }

}

function toggleFilterView() {
    var productSearchWrapper = document.getElementById('product-search-view');
    productSearchWrapper.classList.toggle('show-filters');
}

function enableSearchStates() {
    document.getElementById('filter-search-autocomplete').addEventListener('keyup', toggleSearchClear);
    document.getElementById('filter-search-btn-clear').addEventListener('click', clearSearch);
}

function toggleSearchClear() {
    var searchInput = document.getElementById('filter-search-autocomplete');
    if (searchInput.value.length < 1) { searchInput.classList.remove('show-clear'); }
    else if (searchInput.value.length > 0) { searchInput.classList.add('show-clear'); }
}

function clearSearch() {
    document.getElementById('filter-search-autocomplete').value = '';
    toggleSearchClear();
    updateSearch({ 'Search': '' });
}

function setAutoComplete(communityItems) {
    var nameList = []
    const regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;

    communityItems.forEach(community => {
        if (community.name.length > 3) {
            nameList.push(community.name);
        }
    });
    communityItems.forEach(community => {
        var text = community.description.replace(/ *\<[^>]*\> */g, " ");
        text.replace(regex, ' ').split(' ').forEach(descWord => {
            if (descWord.length > 3 && nameList.includes(descWord) != true) {
                nameList.push(descWord);
            }
        })
    });
    $('#filter-search-autocomplete').autocomplete({
        source: [{
            data: nameList,
            filter: function (items, query) {
                if (query.length >= 3 && items.length > 0) {
                    var result = [];
                    items.forEach(term => {
                        if (term.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                            result.push(term);
                        }
                    });
                    return result;
                }
                return [];
            }
        }],
        minLength: 3,
        visibleLimit: 5.4,
        autoselect: true,
        showHint: false,
        limit: 101
    });
}

function setMapHeight() {
    var vw = $(window).width();
    var filterHeight = $('#product-filter-panel').outerHeight();
    var mapPresetMin = $('#product-search-map').css('min-height').replace('px', '');

    if (mapPresetMin < filterHeight && vw > 479) {
        $('#product-search-map').css('height', filterHeight + 'px');
        $('#product-search-map').css('min-height', filterHeight + 'px');
    }

}

function setFixedFilterScroll() {
    var vw = $(window).width();
  
    // If mobile set filter bar to fixed position...
    if (vw < 769) {
      // Retrieve the header
      var headerItem = document.getElementById('root-header');
      if (headerItem) {
        // Make the filter bar fixed position
        var filterBar = $('#filter-bar-mobile');
        filterBar.css('position', 'fixed');
        filterBar.css('top', headerItem.getBoundingClientRect().bottom);
  
        // Retrieve filter bar item
        var filterBarItem = document.getElementById('filter-bar-mobile');
        if (filterBarItem) {
          var filterBarBottom = filterBarItem.getBoundingClientRect().bottom;
          var filterBarHeight = filterBarItem.getBoundingClientRect().height;
  
          // Set the filter bar top if the header height changes
          $(window).on('scroll', function () {
            // Retrieve the product search view
            var viewItem = document.getElementById('product-search-view');
            if (viewItem) {
              var view = viewItem.getBoundingClientRect().bottom
              if (view < filterBarBottom) {
                var setNewPos = view - filterBarHeight + 'px'
                filterBar.css('top', setNewPos);
              } else {
                filterBar.css('top', headerItem.getBoundingClientRect().bottom);
              }
            }          
          });
        }
      }  
    }
  }

function hideLoader() {
    const player = document.querySelector("lottie-player");
    if (player !== null) {
        player.stop();
    }
    $('#search-loader-outer').hide();
}

const clone = (productData) => {
    return JSON.parse(JSON.stringify(productData));
};

// Google tag manager / analytics function...
var gtmEventViewToggle = function (value) {
    dataLayer.push({
        'pageCatagory': 'community_search',
        'event': 'view_mode_change',
        'viewMode': value,
    })
}

var gtmEventFilters = function (filterCriteria) { // (Interact with Filter) also in products/index.js
    console.log("GTM Event fired (Interact with Filter) on communities");

    var region = "";

    // if this URL is a sub page of /communities, eg /communities/perth-and-wa then the region would be Perth and WA
    var thisURL = window.location.pathname;
    if (thisURL.endsWith("communities")) {
        //fine, extract region from filter
        region = ((filterCriteria.Region !== undefined) ? filterCriteria.Region : "");
    } else {
        // get the substring after communities to set the region filter value 
        region = thisURL.substring(thisURL.lastIndexOf("/")+1);
    }

    // Jacob from JaneLee would like to transfer available filter criteria to a string, hopefully less than 100 characters (GA4 hardlimit).
    var filterArray = [];
    filterArray.push("type:" + ((filterCriteria.CommunityTypes !== undefined) ? filterCriteria.CommunityTypes.join("|") : ""));
    filterArray.push("region:" + region); // this could either be all or on a region community page
    filterArray.push("status:" + ((filterCriteria.Status !== undefined) ? filterCriteria.Status : ""));
    
    var filter = filterArray.join(",");
    if (filter.length > 100) {
        filter = filter.replace("HouseAndLand", "HL");
        filter = filter.replace("CompletedHomes", "Complete");
        filter = filter.replace("Apartments", "Apart");
    }

    dataLayer.push({
        event: 'filter_interaction',
        item_list_name: 'Community List',
        // 'filter_name': 'nameOfFilterHere', //  decided we they were happy enough with complete filter status
        // 'filter_value': 'valueOfFilterHere',
        filter: filter,
        items: gtmCommunities
    })
}

var gtmViewCommunityList = function (data) { //function for (View Community List)
    // needed to confirm what is being asked for in the items field, answer: an array of items where the item_name is repeated info of that in the community object.
    // therefore need to create an array of items to fit that shape

    console.log("GTM Event fired for (View Community List)");

    var items = [];
    function item(name = "", communityName = "", communityRegion = "", communityAvailability = "") {
        this.item_name = name;        
        this.community_name = communityName;
        this.community_region = communityRegion;
        this.community_availability = communityAvailability;
        return this;
    }

    for (var i = 0; i < data.length; i++) {
        items.push(new item(data[i].name, data[i].name, data[i].region, data[i].projectStatus));
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "view_item_list",
        ecommerce: {
            item_list_name: "Community List",
            items: items 
        }
    });
}